<template>
    <v-dialog v-model="dialogState" :max-width="step==3 ? '600px' :'1200px'">
        <v-stepper v-model="step">
            <v-stepper-header class="elevation-0">
                <v-stepper-step
                    :complete="step > 1"
                    step="1"
                >
                    Datos
                </v-stepper-step>

                <v-divider></v-divider>
                
                <v-stepper-step
                    :complete="step > 2"
                    step="2"
                >
                    Subir Firma
                </v-stepper-step>
                
                <v-divider></v-divider>

                <v-stepper-step
                    :complete="step > 3"
                    step="3"
                >
                    Crear Firma
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                    :complete="step > 4"
                    step="4"
                >
                    Subir DNI Anverso
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                    :complete="step > 5"
                    step="5"
                >
                    Subir DNI Reverso
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <FormCuentaDialogo />

                    <v-btn
                        depressed
                        color="success"
                        @click="step = 2"
                        :disabled="formType != 'edit'"
                    >
                        Siguiente
                    </v-btn>

                    <v-btn
                        text
                        color="red"
                        @click="close"
                    >
                        Cerrar
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <FileUpload 
                        action='storage/uploadUserImages'
                        paramName='signature'
                        allowedExtensions="['jpg', 'jpeg', 'png']"
                        icon="mdi-signature-text"
                        :extra_params="getAccountId"
                    />

                    <v-btn
                        depressed
                        color="success"
                        @click="step = 3"
                    >
                        Siguiente
                    </v-btn>
                    <v-btn
                        depressed
                        text
                        color="primary"
                        @click="step = 1"
                        :disabled="formType != 'edit'"
                    >
                        Volver
                    </v-btn>

                    <v-btn
                        text
                        color="red"
                        @click="close"
                    >
                        Cerrar
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <CanvaComponent :render="step==3"/>
                    
                    <v-btn
                        depressed
                        color="success"
                        @click="step = 4"
                    >
                        Siguiente
                    </v-btn>
                    <v-btn
                        depressed
                        text
                        color="primary"
                        @click="step = 2"
                    >
                        Volver
                    </v-btn>

                    <v-btn
                        text
                        color="red"
                        @click="close"
                    >
                        Cerrar
                    </v-btn>
                </v-stepper-content>
                <v-stepper-content step="4">
                    <FileUpload 
                        action='storage/uploadUserImages'
                        paramName='dni_front'
                        allowedExtensions="['jpg', 'jpeg', 'png']"
                        icon="mdi-card-account-details-outline"
                    />

                    <v-btn
                        depressed
                        color="success"
                        @click="step = 5"
                    >
                        Siguiente
                    </v-btn>
                    <v-btn
                        depressed
                        text
                        color="primary"
                        @click="step = 3"
                        :disabled="formType != 'edit'"
                    >
                        Volver
                    </v-btn>

                    <v-btn
                        text
                        color="red"
                        @click="close"
                    >
                        Cerrar
                    </v-btn>
                </v-stepper-content>
                <v-stepper-content step="5">
                    <FileUpload 
                        action='storage/uploadUserImages'
                        paramName='dni_back'
                        allowedExtensions="['jpg', 'jpeg', 'png']"
                        icon="mdi-id-card"
                    />

                    <v-btn
                        depressed
                        text
                        color="primary"
                        @click="step = 4"
                        :disabled="formType != 'edit'"
                    >
                        Volver
                    </v-btn>

                    <v-btn
                        text
                        color="red"
                        @click="close"
                    >
                        Cerrar
                    </v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

import FormCuentaDialogo from '../FormCuenta/FormCuentaDialogo.vue';
import CanvaComponent from '@/components/Canva/CanvaComponent.vue';
import FileUpload from './FileUpload.vue';

export default {
    data: ()=> ({
        step: 1,
    }),
    components: {
        FormCuentaDialogo,
        CanvaComponent,
        FileUpload,
    },
    computed: {
        dialogState: {
			get() {
				let state = false;
				switch (this.formType) {
					case 'create':
						state =
							this.$store.state.rrhh.nuevaCuentaDialogo.isOpen;
						break;
					case 'edit':
						state =
							this.$store.state.rrhh.editarCuentaDialogo.isOpen;
						break;
					case 'open':
						state = this.$store.state.rrhh.viewCuentaDialogo.isOpen;
					default:
						break;
				}
				return state;
			},
			set() {
				switch (this.formType) {
					case 'create':
						this.$store.dispatch('rrhh/closeNuevaCuentaDialogo');
						break;
					case 'edit':
						this.$store.dispatch('rrhh/closeEditarCuentaDialogo');
						break;
					case 'open':
						this.$store.dispatch('rrhh/closeCuentaDialogo');
					default:
						break;
				}
			},
		},
		formType() {
			// "create" si es formulario para crear cuenta o "edit" si es para editar
			let type = '';
			if (this.$store.state.rrhh.nuevaCuentaDialogo.isOpen)
				type = 'create';
			if (this.$store.state.rrhh.editarCuentaDialogo.isOpen)
				type = 'edit';
			if (this.$store.state.rrhh.viewCuentaDialogo.isOpen) type = 'open';

			return type;
		},
        getAccountId() {
            return {'account': this.account}
        },
        ...mapState('rrhh', {
            account: (state) => state.editarCuentaDialogo.form.id,
        }),
    },
    methods: {
        close() {
			switch (this.formType) {
				case 'create':
					this.$store.dispatch('rrhh/closeNuevaCuentaDialogo');
					break;
				case 'edit':
					this.$store.dispatch('rrhh/closeEditarCuentaDialogo');
					break;
				default:
					this.dialogState = false;
					break;
			}
		},
    },

}
</script>